module.exports = __webpack_public_path__ + "static/media/Certificate.bf8cac0a.png";